export default "__VITE_ASSET__vjJVvJY$__"